import { type ISize, type NodeData, nodeTypeIcons } from '@ipfabric/utils';

export const getNodeIconSize = (node: NodeData): ISize => {
  return nodeTypeIcons[node.type].getSize(node.style);
};
